/**
 * Animation primitives for @visioni/ui.
 *
 * This module provides declarative animation building blocks so that feature
 * packages (like a3s-alarm-schedules) can compose rich motion without importing
 * animation engine libraries directly.
 *
 * The animation engine (react-native-reanimated) is an implementation detail
 * of this module — consumers depend on @visioni/ui, not on reanimated.
 */

// --- Hooks -----------------------------------------------------------------
export {
  useAnimatedColorTransition,
  type ColorTransitionConfig,
  type ColorTransitionStops,
} from "./useAnimatedColorTransition";

// --- Components ------------------------------------------------------------
export { PulseEffect, type PulseEffectProps, type PulseVariant } from "./PulseEffect";
export { SpinEffect, type SpinEffectProps, type SpinDirection } from "./SpinEffect";

// --- Re-exports from animation engine (kept minimal) -----------------------
// AnimatedView lets consumers wrap containers that need animated styles
// without importing react-native-reanimated themselves.
export { default as Animated } from "react-native-reanimated";
